/*
** Triptypes
*/
export const LABEL_TRIPTYPE_FLIGHT_WITH_HOTEL_ID = 13000103
export const LABEL_TRIPTYPE_HOTEL_ID = 13000104
export const LABEL_TRIPTYPE_ID = 13
